// Google OAuth is initiated and completed by the API. Browser bundles must never
// contain a client secret, callback credential, or a caller-controlled return URL.
export const GOOGLE_AUTHORIZATION_PATH = '/auth/google/redirect';

const CRM_OAUTH_SURFACES = {
  'kubiqa.com': 'production',
  'www.kubiqa.com': 'production_www',
  'dev.kubiqa.com': 'development',
};

export function googleAuthorizationUrl(
  apiOrigin = process.env.VUE_APP_APIURL,
  hostname = typeof window === 'undefined' ? '' : window.location.hostname
) {
  const origin = typeof apiOrigin === 'string' ? apiOrigin.trim().replace(/\/$/, '') : '';
  const surface = CRM_OAUTH_SURFACES[hostname];

  return origin && surface ? `${origin}${GOOGLE_AUTHORIZATION_PATH}?surface=${surface}` : null;
}

export function googleCallbackOutcome(query = {}) {
  if (query.oauth !== 'google') {
    return null;
  }

  return ['success', 'password_required', 'two_factor_required', 'failed'].includes(query.outcome)
    ? query.outcome
    : null;
}
